import { sendRawRequest } from "@api/clients/axios";
import { deletePushNotificationToken } from "@api/Rest/pushNotification";
import type { LoginResponse } from "@types_def/common/auth.types";
import type { AxiosHttpError } from "@types_def/common/error.types";
import { removeAuth, storeAuthResult } from "@utils/tokenManagement.util";
import axios from "axios";

export type LoginInput = {
  username: string;
  password: string;
};

export type ResendCodeInput = {
  username: string;
};
export async function login(attempt: LoginInput) {
  try {
    const res = await sendRawRequest<LoginInput, LoginResponse>(
      "post",
      "/auth/login-gestion",
      attempt
    );

    const data = res.data;
    switch (data.ChallengeName) {
      case undefined:
        storeAuthResult(data);
        return {
          success: true,
          action: "LOGIN",
          result: data.AuthenticationResult,
        };
      case "NEW_PASSWORD_REQUIRED":
        return {
          success: true,
          action: "NEW_PASSWORD_REQUIRED",
          session: data.Session,
        };
    }
  } catch (err) {
    const axiosError = err as AxiosHttpError;
    if (axiosError.response?.data) {
      if (axiosError.response.data.message === "User is not confirmed.") {
        return { success: true, action: "need-confirm" };
      }
      const error = axiosError.response.data;
      if (error.error === "Unauthorized") {
        return { success: false, action: "Error", message: "Email ou mot de passe incorrect" };
      }
      throw error;
    }
  }

  return {
    success: false,
    action: "Error",
  };
}

type ConfirmInput = {
  username: string;
  code: string;
  password: string;
};
export async function confirmAccount(confirmInput: ConfirmInput) {
  try {
    const { data } = await sendRawRequest<ConfirmInput, LoginResponse>(
      "post",
      "/auth/confirm-signup",
      confirmInput
    );

    switch (data.ChallengeName) {
      case undefined:
        storeAuthResult(data);
        return {
          success: true,
          action: "LOGIN",
          result: data.AuthenticationResult,
        };
      case "NEW_PASSWORD_REQUIRED":
        return {
          success: true,
          action: "NEW_PASSWORD_REQUIRED",
          session: data.Session,
        };
    }
  } catch (err) {
    const axiosError = err as AxiosHttpError;
    if (axiosError.response?.data) {
      if (axiosError.response.data.message === "User is not confirmed.") {
        try {
          await axios.post<ResendCodeInput, never>("/auth/resend-confirmation-code", {
            username: confirmInput.username,
          });
        } catch (_error) {}

        return { success: true, action: "need-confirm" };
      }
    }
  }

  return {
    success: false,
    action: "Error",
  };
}

export function logout() {
  const pushToken = JSON.parse(localStorage.getItem("pushToken") || "{}");
  deletePushNotificationToken({ id: pushToken?.tokenId });
  localStorage.removeItem("pushToken");
  removeAuth();
}
